
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dF5uX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1mHQU = parcelRequire("1mHQU");

const $da4808005ebe12f4$export$3d6d78aad6c8b522 = {
    PAGE_PERMISSIONS: 'Insufficient page permissions: You are not allowed to perform that action.',
    SPACE_PERMSSIONS: 'Insufficient destination space permissions: You are not allowed to perform that action.',
    DELETED_PAGE: 'Source page is in trash',
    DELETED_PAGE_ALT: 'Source page not found',
    SPACE_NOT_FOUND: 'Destination Space not found',
    ARCHIVED_PAGE: 'Source page is archived, cannot be copied'
};


const $6b0b134fe98737dd$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    defaultErrorBlogifyFlagTitle: {
        id: "publish-page-as-blog.flags.error-message-title",
        defaultMessage: "We had an issue publishing the blog"
    },
    defaultErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.error-message-description",
        defaultMessage: "Refresh the page and try again."
    },
    alternativeErrorBlogifyFlagTitle: {
        id: "publish-page-as-blog.flags.alternative-error-message-title",
        defaultMessage: "We can\u2019t convert this page"
    },
    pagePermissionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.page-permissions-error-message-description",
        defaultMessage: "Restrictions have been applied to this item recently that prevent its conversion."
    },
    spacePermissionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.space-permissions-error-message-description",
        defaultMessage: "You need additional permissions in the destination space to convert it."
    },
    pageDeletedErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.page-deleted-error-message-description",
        defaultMessage: "While you were working with this content, it was deleted by someone else."
    },
    spaceRestrictionsErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.space-restrictions-error-message-description",
        defaultMessage: "Restrictions in the destination space prevent this item from being converted."
    },
    archivedPageErrorBlogifyFlagDescription: {
        id: "publish-page-as-blog.flags.archived-page-error-message-description",
        defaultMessage: "While you were working with this page, it was archived by someone else."
    }
});
const $6b0b134fe98737dd$var$fireAnalyticsEvent = ({ createAnalyticsEvent: createAnalyticsEvent, isSuccess: isSuccess, actionSubject: actionSubject, attributes: attributes, source: source, actionSubjectId: actionSubjectId })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: actionSubject,
            action: isSuccess ? 'success' : 'failed',
            source: source,
            ...attributes && {
                attributes: attributes
            },
            ...actionSubjectId && {
                actionSubjectId: actionSubjectId
            }
        }
    }).fire();
};
const $6b0b134fe98737dd$export$5f2fd371a3016b0c = ({ createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject, attributes: attributes, source: source, isSuccess: isSuccess, actionSubjectId: actionSubjectId })=>{
    $6b0b134fe98737dd$var$fireAnalyticsEvent({
        createAnalyticsEvent: createAnalyticsEvent,
        isSuccess: isSuccess,
        actionSubject: actionSubject,
        attributes: attributes,
        source: source,
        actionSubjectId: actionSubjectId
    });
};
const $6b0b134fe98737dd$export$23111a6b0dd1d6ee = ({ flags: flags, createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source, customFlagMessage: customFlagMessage })=>{
    $6b0b134fe98737dd$var$fireAnalyticsEvent({
        createAnalyticsEvent: createAnalyticsEvent,
        isSuccess: false,
        actionSubject: actionSubject,
        attributes: attributes,
        source: source,
        actionSubjectId: actionSubjectId
    });
    flags && flags.showErrorFlag({
        title: customFlagMessage && customFlagMessage.title ? customFlagMessage.title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6b0b134fe98737dd$export$311c03294014fd7d(attributes?.error).title),
        description: customFlagMessage && customFlagMessage.description ? customFlagMessage.description : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6b0b134fe98737dd$export$311c03294014fd7d(attributes?.error).description)
    });
};
const $6b0b134fe98737dd$export$cea7730911ac669 = (errorMessage)=>{
    let knownEditorErrorMessage = '';
    errorMessage && Object.values((0, $1mHQU.ALLOWED_FLAG_MESSAGES)).some(function(value) {
        if (errorMessage.includes(value)) {
            knownEditorErrorMessage = value;
            return true;
        }
    });
    return knownEditorErrorMessage;
};
const $6b0b134fe98737dd$export$c58098ccf6d18998 = (adf)=>{
    if (!adf) throw new Error('Could not get the Editor Content');
};
const $6b0b134fe98737dd$export$311c03294014fd7d = (errorMessage)=>{
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).PAGE_PERMISSIONS)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.pagePermissionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).SPACE_PERMSSIONS)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.spacePermissionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).DELETED_PAGE) || errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).DELETED_PAGE_ALT)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.pageDeletedErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).SPACE_NOT_FOUND)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.spaceRestrictionsErrorBlogifyFlagDescription
    };
    if (errorMessage?.includes((0, $da4808005ebe12f4$export$3d6d78aad6c8b522).ARCHIVED_PAGE)) return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.alternativeErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.archivedPageErrorBlogifyFlagDescription
    };
    return {
        title: $6b0b134fe98737dd$export$a7357cdd1f0b0168.defaultErrorBlogifyFlagTitle,
        description: $6b0b134fe98737dd$export$a7357cdd1f0b0168.defaultErrorBlogifyFlagDescription
    };
};
module.exports["publishFromPageToBlogEvent"] = $6b0b134fe98737dd$export$5f2fd371a3016b0c;
module.exports["publishPageAsBlogFailureEventAndFlag"] = $6b0b134fe98737dd$export$23111a6b0dd1d6ee;
module.exports["blogifyErrorMessage"] = $6b0b134fe98737dd$export$311c03294014fd7d;
module.exports["knownEditorError"] = $6b0b134fe98737dd$export$cea7730911ac669;
module.exports["handleEditorPublishPageAsBlogError"] = $6b0b134fe98737dd$export$c58098ccf6d18998;

});

parcelRegister("3Gp1y", function(module, exports) {
/**
 * @generated SignedSource<<a7351493ce9cbd3fcf0eb44a21739312>>
 * @relayHash 26f5586afcc341d386cda98562e2e244
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 96068d7a1113d99ae587c08d667afa086302750676fd838acb69bb886c235119
const $aa5f10a793fdffa4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "destinationSpaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ncsStepVersion"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "restrictions"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schedulePublishDate"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceStatus"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressNotifyWatchers"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "syncRev"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v13 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentBody",
                            "variableName": "content"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "minorEdit",
                            "variableName": "suppressNotifyWatchers"
                        },
                        {
                            "kind": "Variable",
                            "name": "ncsStepVersion",
                            "variableName": "ncsStepVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "restrictions",
                            "variableName": "restrictions"
                        },
                        {
                            "kind": "Variable",
                            "name": "schedulePublishDate",
                            "variableName": "schedulePublishDate"
                        },
                        {
                            "kind": "Variable",
                            "name": "syncRev",
                            "variableName": "syncRev"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        },
                        {
                            "kind": "Variable",
                            "name": "versionMessage",
                            "variableName": "message"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "confluenceContentInput"
                },
                {
                    "kind": "Variable",
                    "name": "destinationSpaceKey",
                    "variableName": "destinationSpaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "sourceStatus",
                    "variableName": "sourceStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "success"
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            v15 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    }
                ]
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "message"
    }, v18 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConvertPageToBlogMutation",
            "selections": [
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "ConfluenceConvertContentToBlogpostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_convertToBlogpost",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v5 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConvertPageToBlogMutation",
            "selections": [
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "ConfluenceConvertContentToBlogpostPayload",
                    "kind": "LinkedField",
                    "name": "confluence_convertToBlogpost",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v15 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "26f5586afcc341d386cda98562e2e244",
            "id": "96068d7a1113d99ae587c08d667afa086302750676fd838acb69bb886c235119",
            "metadata": {},
            "name": "useConvertPageToBlogMutation",
            "operationKind": "mutation",
            "text": "mutation useConvertPageToBlogMutation($contentId:ID!,$content:String,$message:String,$suppressNotifyWatchers:Boolean,$syncRev:String,$ncsStepVersion:String,$title:String,$version:Int,$schedulePublishDate:String,$restrictions:PageRestrictionsInput,$cloudId:ID!,$destinationSpaceKey:String!,$sourceStatus:String!){confluence_convertToBlogpost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,syncRev:$syncRev,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,title:$title,version:$version,versionMessage:$message},destinationSpaceKey:$destinationSpaceKey,sourceStatus:$sourceStatus}){success,content{status,id,links{webui,editui}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$aa5f10a793fdffa4$var$node.hash = "c1ea39c835722794b607605c89d18ae4";
var $aa5f10a793fdffa4$export$2e2bcd8739ae039 = $aa5f10a793fdffa4$var$node;



var $1KmJq = parcelRequire("1KmJq");


var $6mKj3 = parcelRequire("6mKj3");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $eSUdr = parcelRequire("eSUdr");

const $ca8e02e752f842aa$export$6647dffcc77073c5 = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`mutation PublishPageAsBlogMutation($contentId:String!$destinationType:String!$destinationSpaceKey:String$sourceStatus:String!$content:String$title:String$syncRev:String$ncsStepVersion:String$message:String$suppressNotifyWatchers:Boolean$schedulePublishDate:String$restrictions:ContentRestrictionsObj)@experimental{experimentalPublishPageAsBlog(contentId:$contentId destinationType:$destinationType destinationSpaceKey:$destinationSpaceKey sourceStatus:$sourceStatus content:$content title:$title syncRev:$syncRev ncsStepVersion:$ncsStepVersion message:$message suppressNotifyWatchers:$suppressNotifyWatchers schedulePublishDate:$schedulePublishDate restrictions:$restrictions){id _links{webui editui}status}}`;



var $dF5uX = parcelRequire("dF5uX");


var $iVd6X = parcelRequire("iVd6X");

const $8fb7d9dcdd9bebc2$export$e8a4ab21f72a2af3 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [publishPageAsBlogExperimentalMutation] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $ca8e02e752f842aa$export$6647dffcc77073c5));
    const [convertToBlogpostMutation] = (0, $308Wd.useMutationInterop)((0, $aa5f10a793fdffa4$export$2e2bcd8739ae039));
    const handlePageToBlogConversion = async ({ flags: flags, sourceAction: sourceAction, contentId: contentId, spaceKey: spaceKey, message: message, suppressNotifyWatchers: suppressNotifyWatchers, schedulePublishDate: schedulePublishDate, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onConvertAndPublishSucceed: onConvertAndPublishSucceed, onPublishFail: onPublishFail, onConvertFail: onConvertFail, restrictions: restrictions })=>{
        const variables = {
            contentId: contentId,
            destinationType: 'blogpost',
            sourceStatus: sourceAction === (0, $iVd6X.PublishPageAsBlogSources).EditPage ? 'draft' : 'current',
            destinationSpaceKey: spaceKey || '',
            cloudId: cloudId
        };
        try {
            if (sourceAction === (0, $iVd6X.PublishPageAsBlogSources).EditPage) {
                const { title: title, adf: adf, syncRev: syncRev, ncsStepVersion: ncsStepVersion } = await retrieveEditorTitleAndContent();
                (0, $dF5uX.handleEditorPublishPageAsBlogError)(adf);
                variables['content'] = JSON.stringify(adf);
                variables['title'] = title;
                variables['syncRev'] = syncRev;
                variables['ncsStepVersion'] = ncsStepVersion;
                variables['message'] = message;
                variables['suppressNotifyWatchers'] = suppressNotifyWatchers;
                variables['schedulePublishDate'] = schedulePublishDate;
                restrictions && (variables['restrictions'] = restrictions);
            }
            const { data: data } = (0, $6mKj3.expValEquals)('use_graphql_to_publish_pages_and_blogs', 'isEnabled', true) ? await convertToBlogpostMutation({
                variables: variables
            }) : await publishPageAsBlogExperimentalMutation({
                variables: variables
            });
            const hasConvertedAndPublished = (0, $6mKj3.expValEquals)('use_graphql_to_publish_pages_and_blogs', 'isEnabled', true) ? data?.confluence_convertToBlogpost?.content?.status === 'current' : data?.experimentalPublishPageAsBlog?.status === 'current';
            const links = (0, $6mKj3.expValEquals)('use_graphql_to_publish_pages_and_blogs', 'isEnabled', true) ? data?.confluence_convertToBlogpost?.content?.links : data?.experimentalPublishPageAsBlog?._links;
            // it's possible for the conversion to go through but not the publishing of the blog draft
            if (data && hasConvertedAndPublished) onConvertAndPublishSucceed(data);
            else if (links?.editui && !schedulePublishDate) onPublishFail({
                links: links,
                errorMessage: 'Page has converted to blog but not published',
                flags: flags
            });
            else if (data?.confluence_convertToBlogpost?.errors?.[0]) onConvertFail({
                error: new Error(data?.confluence_convertToBlogpost?.errors?.[0]?.message || 'Unknown error when converting page to blog'),
                flags: flags
            });
        } catch (error) {
            onConvertFail({
                error: error,
                flags: flags
            });
        }
    };
    return handlePageToBlogConversion;
};
module.exports["useConvertPageToBlog"] = $8fb7d9dcdd9bebc2$export$e8a4ab21f72a2af3;

});


//# sourceMappingURL=PublishButtonWithMoreOptions.c01a7953.js.map
